<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'

export default {
  components: { NavBar, SideBar, RightBar },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu(from="btn") {
      // when clicks on content-page, toggles menu || jmg 03-25-2022
      if (from === 'content' && (document.body.clientWidth >= 450 || !document.body.classList.contains('sidebar-enable'))){
        return false;
      }
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      document.body.classList.toggle('enlarged')
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    }
  }
  // mounted: function(){
    // this.toggleMenu()
    // if (localStorage.getItem('isMenuCondensed') === 'true'){
    //   this.toggleMenu()
    // }
  // }
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" :toggleMenu="toggleMenu" />
    <SideBar :isCondensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page" @click="toggleMenu('content')">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid p-1">
          <slot />
        </div>
      </div>
    </div>
    <RightBar />
  </div>
</template>
